import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import { ICONS } from './iconRegistry';

// Logos are hotlinked from cdn.simpleicons.org for review; self-host approved logo assets before publishing.
// Any missing logo falls back to a monogram (the `mono` field), matching the reference design's onerror fallback.
// SQL has no brand logo on Simple Icons (it's a language, not a company) — a generic
// Lucide icon (named in the `lucideIcon` YAML field) stands in for it instead of a bare monogram.
const TechLogo = ({ item, dup }) => {
  const LucideIcon = item.lucideIcon && ICONS[item.lucideIcon];
  return (
    <div className={`${styles.tl} ${item.soft ? styles.soft : ''} ${dup ? styles.dup : ''}`} aria-hidden={dup || undefined}>
      <span className={`${styles.lg} ${item.icon || LucideIcon ? styles.img : styles[item.cls || 'c1']}`}>
        {LucideIcon ? <LucideIcon size={18} aria-hidden="true" /> : item.mono}
        {item.icon && (
          <img src={`https://cdn.simpleicons.org/${item.icon}`} alt="" loading="lazy" onError={(e) => e.currentTarget.remove()} />
        )}
      </span>
      <span>
        <b>{item.name}</b>
        <small>{item.tag}</small>
      </span>
    </div>
  );
};

const TechMarquee = ({ rows }) => {
  return (
    <section id="tech" className={styles.mint}>
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Master AI Engineering With Key Industry Tools</h2>
          <p>
            25+ industry-relevant tools across LLM apps, agents, retrieval, evaluation,
            fine-tuning and production — taught concept-first, so the tools stay swappable as the
            ecosystem evolves.
          </p>
        </div>
        <div className={styles.mqRows}>
          {rows.map((row) => (
            <div className={styles.mqRow} key={row.label}>
              <span className={`${styles.chipG} ${styles.mqLbl}`}>{row.label}</span>
              <div className={styles.mq} data-dir={row.dir}>
                <div className={styles.mqTrack} style={{ animationDuration: `${row.duration}s` }}>
                  {row.items.map((item, i) => (
                    <TechLogo item={item} key={`${row.label}-${i}`} />
                  ))}
                  {row.items.map((item, i) => (
                    <TechLogo item={item} key={`${row.label}-dup-${i}`} dup />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.techFoot}>
          <span>
            <b>25+</b> tools, hands-on
          </span>
          <span>
            <b>6</b> categories, concept-first
          </span>
          <span>
            <b>₹0</b> extra — tools &amp; cloud access included; free tiers wherever sufficient
          </span>
          <a href="#included" className="inline-flex h-[40px] items-center whitespace-nowrap rounded-[10px] border-2 border-black px-4 font-manrope text-sm font-bold text-black transition-all hover:border-v5-green-400 hover:bg-v5-green-400 hover:text-v5-green-100">
            See what&apos;s included →
          </a>
        </div>
      </div>
    </section>
  );
};

export default TechMarquee;
